import {Component} from 'react';
import injectSheet from 'react-jss';

import Button from '-/components/general/Button';
import greetingStyles from '-/styles/sections/greeting';

class DocumentsLanding extends Component {
    render() {
        const {
            classes = {},
            onNextClick,
            applicantName
        } = this.props;

        const buttonText = 'View Your Documents';
        const greeting = `Welcome Back, ${applicantName}`;

        return (
            <section className={classes.root}>
                <h1>{greeting}</h1>
        
                <Button
                    width={90}
                    tag="a"
                    href="#"
                    onClick={onNextClick}
                    title={buttonText}
                    role="button">
                    {buttonText}
                </Button>
            </section>
        );
    }
}

export default injectSheet(greetingStyles)(DocumentsLanding);
